export default __webpack_public_path__ + "static/parkNavPoster-2b3fb5e69b28a87bef7b546b78d52fd3.svg";